<template>
    <v-container>
        <template v-if="status == 1">
            <v-alert
                type="warning"
            >
                Verifying Session... Please Wait...
            </v-alert>
        </template>

        <template v-else-if="status == 2">
            <v-alert
                type="success"
            >
                Redirecting...
            </v-alert>
        </template>

        <template v-else-if="status == 3">
            <v-alert
                type="error"
            >
                Session Verification Failed... Redirecting...
            </v-alert>
        </template>
    </v-container>
</template>

<script>
import axios from "axios"
import moment from "moment"

export default {
    name: 'sessionverify',
    metaInfo: {
        title: 'Digital Tuguegarao - Session Verification',
    },
    data() {
        return {
            status: 1,
        }
    },
    methods: {
        Failed() {
            this.status = 3

            setTimeout(() => {
                window.location.href = decodeURIComponent(this.$route.query.redirect)
            }, 1000)
        },
        Verify() {
            if(!this.$route.params.authid){
                this.Failed()

                return
            }

            axios({
                url: `${this.domain}/crm_session_verification`,
                method: 'post',
                data: {
                    authid: this.$route.params.authid.toString()
                }
            })
                .then(response => {
                    if(response.data.response){
                        this.status = 2

                        setTimeout(() => {
                            this.$session.start()
                            this.$session.set('crmusersessionsignature', response.data.jwt)
                            this.$session.set('crmusersessionauthid', this.$route.params.authid.toString())
                            this.$session.set('crmusersessiontimer', moment().unix())
                            this.$ls.set('isLoggedIn', true)

                            localStorage.setItem('crm_entryauth',response.data.auth)
                            localStorage.setItem('crm_global_details',response.data.jwt)

                            // window.location.href = decodeURIComponent(this.$route.query.redirect)
                            // window.location.href = `http://35.220.187.169/SessionValidator/?authid=${this.$route.params.authid.toString()}&redirect=${this.$route.query.redirect}`
                            // window.location.href = `http://35.220.187.169:3000/sessionverify/${this.$route.params.authid.toString()}?redirect=${decodeURIComponent(this.$route.query.redirect)}`
                            window.location.href = `https://tuguegaraocity.gov.ph/TugueGov/complete?sessionid=${this.$route.params.authid.toString()}&redirect=${decodeURIComponent(this.$route.query.redirect)}`
                            // window.location.href = `https://tuguegaraocity.gov.ph/TugueGov/complete?j=${response.data.jwt}&sessionid=${this.$route.params.authid.toString()}&redirect=${decodeURIComponent(this.$route.query.redirect)}`
                        }, 1000)
                    } else{
                        this.status = 3

                        this.Failed()
                    }
                })
                .catch(() => {
                    this.Failed()
                })
        }
    },
    mounted() {
        this.Verify()
    }
}
</script>